import { useState, useEffect } from "react";

import { fetchWithToken } from "src/hooks/useFetch";
import { useAuth } from "src/contexts/auth";
import { GenericHeatmap } from "src/components/GenericHeatmap";

interface UtilizationForInstrument {
  tenant: string;
  serialNumber: string;
  utilization: number[];
}

interface HeatmapElement {
  val: number;
  label: string;
}
interface HeatmapData {
  rowLabels: string[];
  data: HeatmapElement[][];
}

const InternalUtilization = () => {
  const { getAccessTokenSilently } = useAuth();

  const [heatmapData, setHeatmapData] = useState<HeatmapData>();

  useEffect(() => {
    fetchWithToken(getAccessTokenSilently, "/utilization?internal").then(
      (resp: UtilizationForInstrument[]) => {
        const rowLabels = resp.map((v) => `${v.serialNumber}`);
        const data: HeatmapElement[][] = [];
        for (let i = 0; i < resp.length; i++) {
          data.push(
            resp[i].utilization.map((v) => {
              if (v < 0) return { val: NaN, label: "" };
              return { val: v * 100, label: (v * 100).toFixed(0) };
            })
          );
        }
        setHeatmapData({ rowLabels, data });
      }
    );
  }, [getAccessTokenSilently]);

  return (
    <div
      style={{
        height: "100%",
        marginLeft: 80,
        marginTop: 30,
      }}
    >
      {heatmapData && (
        <GenericHeatmap
          title="Internal Utilization"
          data={heatmapData.data}
          rowlabels={heatmapData.rowLabels}
          minv={0}
          maxv={100}
          tooltipprecision={1}
          hidelegend={false}
          scale={2}
          nogap
          zeroAsWhite
          maxH="75%"
        />
      )}
    </div>
  );
};

export default InternalUtilization;
